import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import {useContacts} from "@/app/user/messages/hooks/use-contacts.ts";
import {useStartDM} from "@/app/user/messages/hooks/use-start-dm.ts";

interface Props { open: boolean; onOpenChange: (o: boolean) => void; }

export default function NewChatModal({ open, onOpenChange }: Props) {
    const { contacts, loading } = useContacts();
    const {startDM} = useStartDM();
    const [search, setSearch] = useState('');

    const filtered = contacts.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Start a new chat</DialogTitle>
                </DialogHeader>

                <Input
                    placeholder="Search people…"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    className="mb-4"
                />

                <div className="max-h-72 overflow-y-auto space-y-2">
                    {loading && <p className="text-sm text-muted-foreground px-2">Loading…</p>}
                    {!loading && filtered.map(c => (
                        <Button
                            key={c.id}
                            variant="ghost"
                            className="w-full justify-start"
                            onClick={() => {
                                startDM(c);
                                onOpenChange(false);
                            }}
                        >
                            <Avatar className="mr-3 h-7 w-7">
                                <AvatarImage src={c.avatar ?? undefined} />
                                <AvatarFallback>{c.name.slice(0,2).toUpperCase()}</AvatarFallback>
                            </Avatar>
                            <span className="truncate">{c.name}</span>
                        </Button>
                    ))}
                    {!loading && filtered.length === 0 && (
                        <p className="text-sm text-muted-foreground px-2">No contacts found.</p>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}